import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action, makeObservable } from "mobx";
import Ellipsoid from "terriajs-cesium/Source/Core/Ellipsoid";
import CesiumMath from "terriajs-cesium/Source/Core/Math";
import Rectangle from "terriajs-cesium/Source/Core/Rectangle";
import CommonStrata from "../../Models/Definition/CommonStrata";
import SearchProviderMixin from "./SearchProviderMixin";
function LocationSearchProviderMixin(Base) {
  var _class;
  let LocationSearchProviderMixin = (_class = class LocationSearchProviderMixin extends SearchProviderMixin(Base) {
    constructor() {
      super(...arguments);
      makeObservable(this);
    }
    get hasLocationSearchProviderMixin() {
      return true;
    }
    toggleOpen() {
      let stratumId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : CommonStrata.user;
      this.setTrait(stratumId, "isOpen", !this.isOpen);
    }
    showWarning() {}
    supportsAutocomplete() {
      return true;
    }
  }, _applyDecoratedDescriptor(_class.prototype, "toggleOpen", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showWarning", [action], Object.getOwnPropertyDescriptor(_class.prototype, "showWarning"), _class.prototype), _class);
  return LocationSearchProviderMixin;
}
export function getMapCenter(terria) {
  const view = terria.currentViewer.getCurrentCameraView();
  if (view.position !== undefined) {
    const cameraPositionCartographic = Ellipsoid.WGS84.cartesianToCartographic(view.position);
    return {
      longitude: CesiumMath.toDegrees(cameraPositionCartographic.longitude),
      latitude: CesiumMath.toDegrees(cameraPositionCartographic.latitude)
    };
  } else {
    const center = Rectangle.center(view.rectangle);
    return {
      longitude: CesiumMath.toDegrees(center.longitude),
      latitude: CesiumMath.toDegrees(center.latitude)
    };
  }
}
(function (_LocationSearchProviderMixin) {
  function isMixedInto(model) {
    return model && model.hasLocationSearchProviderMixin;
  }
  _LocationSearchProviderMixin.isMixedInto = isMixedInto;
})(LocationSearchProviderMixin || (LocationSearchProviderMixin = {}));
export default LocationSearchProviderMixin;